import React, {useMemo} from 'react';
import styles from './AdminsTable.module.scss';
import {Avatar, TableColumnConfig, Text} from '@gravity-ui/uikit';
import {AdminModel} from '../../entities';
import {formatDateToLocalDate, DataTable, StatusLabel, useAvatarCache, getUncachedImageUrl} from '../../shared';
import {useNavigate} from 'react-router';

interface AdminsTableProps {
  admins: AdminModel[];
  isLoading: boolean;
}

export const AdminsTable = ({admins, isLoading}: AdminsTableProps) => {
  const navigate = useNavigate();
  const SKELETON_ROWS = 5;
  const {avatarCacheVersion} = useAvatarCache();

  const handleRowClick = (admin: AdminModel) => {
    navigate(`/accounts/admins/profile/${admin.id}`);
  };

  const columns = useMemo<TableColumnConfig<AdminModel>[]>(
    () => [
      {
        id: 'displayName',
        name: 'Имя',
        template: (item: AdminModel) => (
          <div className={styles.userCellContainer}>
            <Avatar
              imgUrl={getUncachedImageUrl(item.avatarUrl || '', avatarCacheVersion)}
              text={item.displayName ? item.displayName[0] : '?'}
              size="s"
            />
            <Text variant="body-1">{item.displayName}</Text>
          </div>
        ),
      },
      {
        id: 'lockedAt',
        name: 'Статус',
        template: (item: AdminModel) => <StatusLabel lockedAt={item.lockedAt} lastLoggedInAt={item.lastLoggedInAt} />,
      },
      {
        id: 'email',
        name: 'Почта',
        template: (item: AdminModel) => item.email,
      },
      {
        id: 'createdAt',
        name: 'Дата регистрации',
        template: (item: AdminModel) => formatDateToLocalDate(item.createdAt),
      },
    ],
    [avatarCacheVersion],
  );

  return (
    <div className={styles.tableContainer}>
      <DataTable<AdminModel>
        isLoading={isLoading}
        data={admins || []}
        columns={columns}
        edgePadding={false}
        skeletonRowCount={SKELETON_ROWS}
        emptyStateTitle="Администратор не найден"
        emptyStateDescription="Администратор с таким именем или адресом почты не найден. Попробуйте изменить запрос"
        onRowClick={handleRowClick}
      />
    </div>
  );
};
